import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageAccess } from '../services/stats/PageStatsService';

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        const path = location.pathname + location.search;

        // Don't track admin pages or internal technical paths
        if (path.startsWith('/admin') || path.startsWith('/login') || path === '/test.html') {
            return;
        }

        trackPageAccess(path);
    }, [location]);
};
